<script lang="ts">
  export let height = 4
  export let absolute = false
  export let fixed = false
  export let active = true
  export let value = 0
  export let indeterminate = false
</script>

<div
  class="container"
  class:absolute
  class:active
  class:fixed
  class:indeterminate
  role="progressbar"
  aria-hidden={!active}
  aria-valuemin={0}
  aria-valuemax={100}
  aria-valuenow={indeterminate ? undefined : value}
  style={active ? `height: ${height}px` : 'height: 0px'}
>
  <div class="background"></div>
  {#if indeterminate}
    <div class="indeterminate">
      <div class="long" class:active></div>
      <div class="short" class:active></div>
    </div>
  {:else}
    <div class="determinate" style={`width: ${value}%`}></div>
  {/if}
</div>

<style lang="scss">
  .container {
    background: transparent;
    overflow: hidden;
    position: relative;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;

    &.absolute,
    &.fixed {
      left: 0;
      z-index: 14;
    }

    &.absolute {
      position: absolute;
    }

    &.fixed {
      position: fixed;
    }

    .background {
      position: absolute;
      bottom: 0;
      left: 0;
      top: 0;
      background: var(--linear-progress-background-color, var(--color-primary));
      opacity: 0.12;
      width: 100%;
    }

    .indeterminate,
    .determinate {
      background: var(--linear-progress-color, var(--color-primary));
    }

    .indeterminate {
      .long,
      .short {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: auto;
        height: inherit;
        width: auto;
        background: inherit;
        animation-play-state: paused;
        animation-duration: 2.2s;
        animation-iteration-count: infinite;
        will-change: left, right;

        &.active {
          animation-play-state: running;
        }
      }

      .long {
        animation-name: indeterminate-ltr;
      }

      .short {
        animation-name: indeterminate-short-ltr;
      }

      @keyframes indeterminate-ltr {
        0% {
          left: -90%;
          right: 100%;
        }
        60% {
          left: -90%;
          right: 100%;
        }
        100% {
          left: 100%;
          right: -35%;
        }
      }

      @keyframes indeterminate-short-ltr {
        0% {
          left: -200%;
          right: 100%;
        }
        60% {
          left: 107%;
          right: -8%;
        }
        100% {
          left: 107%;
          right: -8%;
        }
      }
    }

    .determinate {
      position: absolute;
      left: 0;
      height: inherit;
      transition: inherit;
      transition-property: width;
    }
  }
</style>
